import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2cb6150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder text-light m-0" }
const _hoisted_5 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Tranche", -1))
const _hoisted_14 = ["label", "value"]
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Partner", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Contract", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Contract", -1))
const _hoisted_22 = ["label", "value"]
const _hoisted_23 = { class: "col-md-2 mt-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "mt-6" }
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "collapse show" }
const _hoisted_29 = { class: "card-body border-top p-0" }
const _hoisted_30 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_31 = { class: "table-responsive" }
const _hoisted_32 = { class: "table table-borderless gy-4 m-0" }
const _hoisted_33 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }
const _hoisted_34 = { rowspan: "2" }
const _hoisted_35 = ["data-bs-target"]
const _hoisted_36 = { rowspan: "2" }
const _hoisted_37 = ["data-kt-indicator"]
const _hoisted_38 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_39 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_40 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Tranche", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Contract", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Bill", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Claim", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Batches", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Total Trainee", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Gross Amount", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Net Amount", -1))
const _hoisted_51 = {
  class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary",
  style: {"border-top":"1px solid\r\n                                      rgba(29, 182, 140, 0.51) !important"}
}
const _hoisted_52 = ["id"]
const _hoisted_53 = ["id"]
const _hoisted_54 = { class: "collapse show" }
const _hoisted_55 = { class: "card-body border-top p-6" }
const _hoisted_56 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_57 = { class: "table-responsive mt-5" }
const _hoisted_58 = { class: "table table-borderless gy-4" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }, " Training Institutes "),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "BN"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Count"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit Cost"),
    /*#__PURE__*/_createElementVNode("th", null, "Pay %"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill Date")
  ])
], -1))
const _hoisted_60 = { style: {} }
const _hoisted_61 = { class: "align-middle" }
const _hoisted_62 = { class: "align-middle" }
const _hoisted_63 = { class: "align-middle" }
const _hoisted_64 = { class: "align-middle" }
const _hoisted_65 = { class: "align-middle" }
const _hoisted_66 = { class: "align-middle" }
const _hoisted_67 = { class: "align-middle" }
const _hoisted_68 = { class: "align-middle" }
const _hoisted_69 = { class: "align-middle" }
const _hoisted_70 = { class: "align-middle" }
const _hoisted_71 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold text-primary" }, " Total ", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_75 = { class: "font-weight-bold text-primary" }
const _hoisted_76 = { class: "font-weight-bold text-primary" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_80 = { class: "font-weight-bold text-primary" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_82 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " A) Gross Amount ", -1))
const _hoisted_84 = { class: "font-weight-bold text-primary" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_86 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " B) IA'S Contribution ", -1))
const _hoisted_88 = { class: "font-weight-bold text-primary" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_90 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " C) Contribution Amount (A*B) ", -1))
const _hoisted_92 = { class: "font-weight-bold text-primary" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " D) Net Payable (A - C) ", -1))
const _hoisted_95 = { class: "font-weight-bold text-primary" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Claim2ReassessmentApproveModal = _resolveComponent("Claim2ReassessmentApproveModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, " Claim-2 Reassessment: Submitted Bills for " + _toDisplayString(_ctx.entity_short_name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control py-2",
                    placeholder: "Select Tranche",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                    style: {"width":"100%"}
                  }, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, _toDisplayString(trans.label), 9, _hoisted_14))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.bill.tranche_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control py-2",
                    placeholder: "Select Partner",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                    style: {"width":"100%"},
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.entityNameChange(_ctx.bill.entity_id)))
                  }, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: data.id,
                        value: data.id
                      }, " [" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 9, _hoisted_18))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.bill.entity_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control py-2",
                    placeholder: "Select Contract",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                    style: {"width":"100%"}
                  }, [
                    _hoisted_21,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: data.id,
                        label: data.contract_name,
                        value: data.id
                      }, _toDisplayString(data.contract_name), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.bill.entity_contract_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getBillList())),
                    type: "submit",
                    class: "btn btn-success p-3 mt-6",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_24
                  ])
                ])
              ]),
              (_ctx.showBillList)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("h4", _hoisted_26, " Claim-2 Reassessment Bill Detail (Total Bill Found : " + _toDisplayString(_ctx.billList.length) + ") ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billList, (bl, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "card mb-5 mb-xl-10 mt-4"
                      }, [
                        _createElementVNode("div", {
                          id: ['claim_' + index + '_bill_data'],
                          class: "collapse show"
                        }, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("table", _hoisted_32, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", _hoisted_33, [
                                        _createElementVNode("th", _hoisted_34, [
                                          _createElementVNode("i", {
                                            class: "fas fa-angle-down text-primary fs-2x",
                                            role: "button",
                                            "data-bs-toggle": "collapse",
                                            "data-bs-target": ['#billList' + index],
                                            "aria-expanded": "false",
                                            "aria-controls": "form"
                                          }, null, 8, _hoisted_35)
                                        ]),
                                        _createElementVNode("th", _hoisted_36, [
                                          _createElementVNode("button", {
                                            "data-kt-indicator": _ctx.loading ? 'on' : null,
                                            class: "btn btn-sm btn-dark ml-3 p-3",
                                            title: "Invoice",
                                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                                            type: "submit"
                                          }, [
                                            (!_ctx.loading)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                  _createTextVNode(" Invoice "),
                                                  _createElementVNode("span", _hoisted_39, [
                                                    _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.loading)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                                  _createTextVNode(" Please wait... "),
                                                  _hoisted_41
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_37),
                                          _createElementVNode("button", {
                                            "data-kt-drawer-toggle": "true",
                                            "data-kt-drawer-target": "#kt_drawer_claim_2_reassessment_approve",
                                            onClick: ($event: any) => (_ctx.approve(bl)),
                                            id: "kt_drawer_claim_2_reassessment_approve_button",
                                            title: "Approve",
                                            class: "btn btn-sm btn-success ml-3 p-3"
                                          }, " Approve ", 8, _hoisted_42)
                                        ]),
                                        _hoisted_43,
                                        _hoisted_44,
                                        _hoisted_45,
                                        _hoisted_46,
                                        _hoisted_47,
                                        _hoisted_48,
                                        _hoisted_49,
                                        _hoisted_50
                                      ]),
                                      _createElementVNode("tr", _hoisted_51, [
                                        _createElementVNode("th", null, _toDisplayString(bl?.tranche_label), 1),
                                        _createElementVNode("th", null, _toDisplayString(bl?.contract), 1),
                                        _createElementVNode("th", null, _toDisplayString(bl?.bill_sequence_no), 1),
                                        _createElementVNode("th", null, _toDisplayString(bl?.claim_no), 1),
                                        _createElementVNode("th", null, _toDisplayString(bl?.total_batch), 1),
                                        _createElementVNode("th", null, _toDisplayString(bl?.total_trainee), 1),
                                        _createElementVNode("th", null, _toDisplayString(bl?.gross_amount), 1),
                                        _createElementVNode("th", null, _toDisplayString(bl?.net_amount), 1)
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  id: ['billList' + index],
                                  class: "collapse card mb-5 mb-xl-10 m-5"
                                }, [
                                  _createElementVNode("div", {
                                    id: ['claim_' + index + '_bill_dta'],
                                    class: "collapse show"
                                  }, [
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("div", _hoisted_56, [
                                          _createElementVNode("div", _hoisted_57, [
                                            _createElementVNode("table", _hoisted_58, [
                                              _hoisted_59,
                                              _createElementVNode("tbody", _hoisted_60, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bl.bill_list, (data, ix) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    key: ix,
                                                    style: {"border-bottom":"1px solid\r\n                                                  rgba(29, 182, 140, 0.51) !important"}
                                                  }, [
                                                    _createElementVNode("td", _hoisted_61, _toDisplayString(ix + 1), 1),
                                                    _createElementVNode("td", _hoisted_62, _toDisplayString(data?.institute_info
                                                    ?.institute_name) + " ( " + _toDisplayString(data?.institute_info
                                                    ?.short_name) + " ) ", 1),
                                                    _createElementVNode("td", _hoisted_63, _toDisplayString(data?.course_info?.course_name) + " | " + _toDisplayString(data?.course_info?.month) + " | " + _toDisplayString(data?.course_info?.hour) + " | " + _toDisplayString(data?.course_info
                                                    ?.total_course_cost), 1),
                                                    _createElementVNode("td", _hoisted_64, _toDisplayString(data?.batch_info?.batch_sequence_number), 1),
                                                    _createElementVNode("td", _hoisted_65, _toDisplayString(data.trainee_count), 1),
                                                    _createElementVNode("td", _hoisted_66, _toDisplayString(data.unit_cost), 1),
                                                    _createElementVNode("td", _hoisted_67, _toDisplayString(data.pay_percentage), 1),
                                                    _createElementVNode("td", _hoisted_68, _toDisplayString(data.net_payable), 1),
                                                    _createElementVNode("td", _hoisted_69, _toDisplayString(data.bill_amount), 1),
                                                    _createElementVNode("td", _hoisted_70, _toDisplayString(data.bill_date), 1)
                                                  ]))
                                                }), 128))
                                              ]),
                                              _createElementVNode("tfoot", null, [
                                                _createElementVNode("tr", _hoisted_71, [
                                                  _hoisted_72,
                                                  _hoisted_73,
                                                  _hoisted_74,
                                                  _createElementVNode("th", _hoisted_75, _toDisplayString(bl?.total_batch), 1),
                                                  _createElementVNode("th", _hoisted_76, _toDisplayString(bl?.total_trainee), 1),
                                                  _hoisted_77,
                                                  _hoisted_78,
                                                  _hoisted_79,
                                                  _createElementVNode("th", _hoisted_80, _toDisplayString(bl?.gross_amount.toFixed(2)), 1),
                                                  _hoisted_81
                                                ]),
                                                _createElementVNode("tr", _hoisted_82, [
                                                  _hoisted_83,
                                                  _createElementVNode("th", _hoisted_84, _toDisplayString(bl?.gross_amount.toFixed(2)), 1),
                                                  _hoisted_85
                                                ]),
                                                _createElementVNode("tr", _hoisted_86, [
                                                  _hoisted_87,
                                                  _createElementVNode("th", _hoisted_88, _toDisplayString(bl?.contribution_percentage) + "% ", 1),
                                                  _hoisted_89
                                                ]),
                                                _createElementVNode("tr", _hoisted_90, [
                                                  _hoisted_91,
                                                  _createElementVNode("th", _hoisted_92, _toDisplayString(bl?.contribution_amount.toFixed(
                                                  2
                                                )), 1),
                                                  _hoisted_93
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_94,
                                                  _createElementVNode("th", _hoisted_95, _toDisplayString(bl?.net_amount.toFixed(2)), 1),
                                                  _hoisted_96
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ], 8, _hoisted_53)
                                ], 8, _hoisted_52)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_27)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    _createVNode(_component_Claim2ReassessmentApproveModal)
  ], 64))
}